"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIconButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var faSpinner_1 = require("@fortawesome/pro-solid-svg-icons/faSpinner");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var material_1 = require("@mui/material");
var react_router_dom_1 = require("react-router-dom");
var Tooltip_1 = __importDefault(require("atomicComponents/atoms/Tooltip"));
var general_1 = require("utils/general");
exports.StyledIconButton = (0, material_1.styled)(material_1.IconButton, { shouldForwardProp: (0, general_1.omitProps)('outlined', 'isCircle', 'mt', 'neutralByDefault') })(function (_a) {
    var _b;
    var theme = _a.theme, _c = _a.outlined, outlined = _c === void 0 ? false : _c, isCircle = _a.isCircle, mt = _a.mt, neutralByDefault = _a.neutralByDefault;
    return (__assign({ borderRadius: isCircle ? '50%' : 4, marginTop: mt && theme.spacing(mt), backgroundColor: outlined ? theme.palette.common.white : 'initial', ':hover': {
            borderColor: outlined ? 'initial' : 'transparent',
            backgroundColor: outlined ? theme.palette.common.white : '',
        } }, (neutralByDefault && {
        color: (_b = theme.palette.neutral) === null || _b === void 0 ? void 0 : _b.dark,
    })));
});
var IconButton = function (_a) {
    var icon = _a.icon, _b = _a.iconSize, iconSize = _b === void 0 ? 16 : _b, tooltipTitle = _a.tooltipTitle, outlined = _a.outlined, isCircle = _a.isCircle, url = _a.url, _c = _a.targetUrl, targetUrl = _c === void 0 ? '_blank' : _c, isSending = _a.isSending, rest = __rest(_a, ["icon", "iconSize", "tooltipTitle", "outlined", "isCircle", "url", "targetUrl", "isSending"]);
    return ((0, jsx_runtime_1.jsx)(Tooltip_1.default, __assign({ variant: "dark", title: tooltipTitle || '', placement: "bottom", disableInteractive: true }, { children: (0, jsx_runtime_1.jsx)(exports.StyledIconButton, __assign({ outlined: outlined, isCircle: isCircle, 
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            component: url ? react_router_dom_1.Link : 'button', to: url && { pathname: url }, target: targetUrl, href: url }, rest, { disabled: isSending || rest.disabled }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: isSending ? faSpinner_1.faSpinner : icon, style: { fontSize: iconSize }, pulse: isSending }) })) })));
};
exports.default = IconButton;
